<template>
	<div class="h-100">
		<ag-grid :options="componentOptions.table" :data="settings.productFloatingJsons" @row_dbClicked="(x) => resolve(x)" :tabindex="101" ref="table"></ag-grid>
	</div>
</template>

<script>
	import Merge from 'lodash/merge'

	const NAME = 'product-floating-jsons-view'

	export default {
		name: NAME,
		modal: {
			stateUID: NAME,
			size: 'md'
		},
		props: {
			options: {
				type: Object,
			}
		},
		watch: {
			options: {
				immediate: true,
				deep: true,
				handler(val) {
					this.settings = Merge({}, this.settings, val)
					this.settings.productFloatingJsons = this.settings.productFloatingJsons?.filter(x => x.productFloatingValues && x.productFloatingValues.length > 0)
				},
			},
		},
		mounted() {
			this.prepareWindow(this.$t('sale.product-floating-list.title'))
		},
		data() {
			return {
				settings: {
					productFloatingJsons: []
				},
				componentOptions: {
					table: {
						id: this.$options.name,
						doubleClickedToSelect: true,
						enterToSelect: true,
						rowGroupPanelShow: true,
						groupIncludeTotalFooter: false,
						cellSelectionAggReport: false,
						pagination: true,
						fitToWidth: false,
						sideBar: 'none',
						rowSelection: {
							mode: 'singleRow'
						},
						columnDefs: [
							{
								field: 'rowNumber',
								headerName: this.$t('row-number'),
								aggFunc: 'count',
								width: 100,
								maxWidth: 150,
							},
							{
								field: 'productFloatingValues',
								headerName: this.$t('sale.product-request.f.product-center'),
								contentType: 'enum',
								aggFunc: 'count',
								valueFormatter: data => typeof data.value === 'string' ? data.value : data.value?.map(productFloatingValue => productFloatingValue.title).join(', ')
							},
						]
					}
				}
			}
		}
	}
</script>

<style></style>